export var CalloutIntent;
(function (CalloutIntent) {
    CalloutIntent["Default"] = "default";
    CalloutIntent["Primary"] = "primary";
    CalloutIntent["Success"] = "success";
    CalloutIntent["Warning"] = "warning";
    CalloutIntent["Danger"] = "danger";
})(CalloutIntent || (CalloutIntent = {}));
export const CalloutPluginID = 'callout';
